export default function delay(res,time=1000){
	return new Promise((resolve,reject) => setTimeout(() => resolve(res),time));
}
